export type PanelNames = 'board' | 'boardSwitcher' | 'inbox' | 'planner';

export type Panels = {
  inbox: boolean;
  planner: boolean;
  board: boolean;
};

export type PanelWidth = {
  width: number;
  minWidth: number;
  maxWidth: number;
};

export type PanelWidths = {
  [key: string]: PanelWidth;
  inbox: PanelWidth;
  planner: PanelWidth;
  board: PanelWidth;
};

export const INBOX_MIN_WIDTH = 272;
export const PLANNER_MIN_WIDTH = 400;
export const BOARD_MIN_WIDTH = 400;

export const DEFAULT_PANEL_WIDTHS = {
  inbox: {
    minWidth: INBOX_MIN_WIDTH,
    width: INBOX_MIN_WIDTH,
    maxWidth: INBOX_MIN_WIDTH,
  },
  planner: {
    minWidth: PLANNER_MIN_WIDTH,
    width: PLANNER_MIN_WIDTH,
    maxWidth: PLANNER_MIN_WIDTH,
  },
  board: {
    minWidth: BOARD_MIN_WIDTH,
    width: BOARD_MIN_WIDTH,
    maxWidth: BOARD_MIN_WIDTH,
  },
} as PanelWidths;
